import { useTableActionContext } from '@aibees/elephant/context';
import { FeatureFlags, SearchType } from '@aibees/elephant/types';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';

export function useExportTemplateDisabled() {
  // Use the flow's effective search type (folds in the ActionButton override) so
  // template gating matches the record, not just the page route.
  const { effectiveSearchType: type } = useTableActionContext();

  const { isFeatureEnabled } = useFeatureFlagsContext();

  const isPeopleExportTempalteEnabled = isFeatureEnabled(
    FeatureFlags.PEOPLE_EXPORT_TEMPLATE
  );
  const isCompanyExportTemplateEnabled = isFeatureEnabled(
    FeatureFlags.COMPANY_EXPORT_TEMPLATE
  );

  return (
    (type === SearchType.People && !isPeopleExportTempalteEnabled) ||
    (type === SearchType.Company && !isCompanyExportTemplateEnabled)
  );
}
